import { useTranslation } from 'react-i18next';

// The `--- or ---` rule separating alternative login methods on the login
// screen (passkey / email / social).
const OrDivider = () => {
  const { t } = useTranslation();

  return (
    <div className="is-flex is-align-items-center my-4">
      <hr className="is-flex-grow-1" />
      <span className="mx-3 has-text-grey is-size-7">{t('login.or_divider')}</span>
      <hr className="is-flex-grow-1" />
    </div>
  );
};

export default OrDivider;
